<template>
  <BliModal
    :active="isModalVisible"
    width="medium"
    class="agreement-modal"
    @close="onLaterOrClose"
  >
    <BliModalHeader @close="onLaterOrClose">
      <template #title>
        {{ agreement?.title || '' }}
      </template>
    </BliModalHeader>

    <BliModalBody>
      <div class="agreement-body">
        <div
          v-if="agreement?.imageUrl"
          class="agreement-image"
        >
          <img
            :src="agreement.imageUrl"
            :alt="agreement?.title || 'agreement'"
          >
        </div>

        <div
          v-if="agreement?.description"
          class="agreement-description"
        >
          {{ agreement.description }}
        </div>

        <a
          v-if="agreement?.linkUrl"
          class="agreement-link"
          href="#"
          @click.prevent="onAgreementLinkClick"
        >
          {{ agreement.linkUrl }}
        </a>

        <div
          v-if="statements.length"
          class="agreement-statements"
        >
          <BliCheckbox
            v-for="(statement, idx) in statements"
            :key="idx"
            v-model="checked[idx]"
            class="agreement-checkbox"
          >
            {{ statement }}
          </BliCheckbox>
        </div>
      </div>
    </BliModalBody>

    <BliModalFooter long-action>
      <BliButton
        prominence="tertiary"
        color="common"
        @click="onLaterClick"
      >
        {{ $t('common.later') }}
      </BliButton>
      <BliButton
        prominence="primary"
        color="common"
        :disabled="!isAllChecked"
        :loading="isLoading"
        @click="onAgreeClick"
      >
        {{ $t('common.agreeAndContinue') }}
      </BliButton>
    </BliModalFooter>
  </BliModal>
</template>

<script src="./index.js" />

<style scoped lang="scss">
  html:not([dark]) {
    @import '@blibli/blue-design-tokens/dist/tokens-default.scss';
    @import './index.scss';
  }
  html[dark] {
    @import '@blibli/blue-design-tokens/dist/tokens-dark.scss';
    @import './index.scss';
  }
</style>

